import { type Client, OpenFeature } from '@openfeature/web-sdk';

import { DATADOG_OPENFEATURE_DOMAIN } from '../providers/datadogProvider';
import { HARNESS_OPENFEATURE_DOMAIN } from '../providers/harnessProvider';
import type { FeatureFlagProvider } from './featureFlagClient.types';

const DEFAULT_PROVIDER: FeatureFlagProvider = 'datadog';

const providerDomains: Record<FeatureFlagProvider, string> = {
  datadog: DATADOG_OPENFEATURE_DOMAIN,
  harness: HARNESS_OPENFEATURE_DOMAIN,
};

export function normalizeFeatureFlagProvider(provider?: FeatureFlagProvider): FeatureFlagProvider {
  switch (provider) {
    case 'datadog':
      return 'datadog';
    case 'harness':
      return 'harness';
    case undefined:
      // Legacy bridge calls omit the provider, so continue routing them to Datadog.
      return DEFAULT_PROVIDER;
    default:
      throw new Error(`[FeatureFlags] Unsupported provider: ${String(provider)}`);
  }
}

export function getFeatureFlagClient(provider?: FeatureFlagProvider): Client {
  return OpenFeature.getClient(providerDomains[normalizeFeatureFlagProvider(provider)]);
}
